<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/verify-identity">
              <h6 class="login-highlight">Back</h6></router-link
            >
            <div class="left-login">
              <div class="rep-icon-login">
                <img
                src="../../assets/images/member-login.svg"
                    alt="image-fluid"
                />
              </div>
            </div>
            <div>
              <h4 class="login-title mb-2">Verify OTP</h4>
            </div>
            <div class="auth-form pt-1 pb-3">
              <form class="">
                <div>
                  <div class="d-flex justify-content-between">
                    <div class="">
                      <label class="opt-label mt-0"
                      >Enter OTP<span class="required-label"> *</span></label
                      >
                    </div>
                    <!-- <div class="d-flex">
                      <b-spinner v-if="otpLoader" small class="mr-3 login-highlight"></b-spinner>
                      <OTPTimer @sendOTP="sendOTP" :expirySecond=60  :hideTimerContent="true" />
                    </div> -->
                  </div>
                  <div class="opt-num-wrap">
                    <v-otp-input
                        @on-complete="onChangeOTP"
                        @on-change="handleOnChange"
                        ref="otpInput"
                        :input-classes="errorClass +' otp-input'"
                        separator="-"
                        :num-inputs="6"
                        :should-auto-focus="true"
                        :is-input-num="true"
                        input-type="text"
                    />
                  </div>
                </div>
                <div class="valid-error mt-2" v-if="otpErrorFlag">
                  {{ errorMsg }}
                </div>
              </form>
              <button 
                @click="verifyToken" 
                class="submit-btn mt-3 next-btn ml-0" 
                type="button"
                :disabled="otp.length !== 6 || formLoader"
              >
                <b-spinner v-if="formLoader" small  />
                Verify OTP
              </button>
              <login-otp  @sendOTP="sendOTP" :expirySecond=60 :setSpinnerLoader="otpLoader" />
              <!-- <div class="resend-timer-wrap">
                    <div>
                      <span class=""><i class="fa fa-clock me-1 clock-icon"></i> Remaining Time: </span><span class="resend-timer"> 01:03 Sec</span>
                    </div>
                    <div class="dim-light">Resend Code</div>
              </div> -->
            </div>
            <div>
             <!-- <submit-issue /> -->
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
          <login-in-carsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import helper from "@/resource/Helper";
import Logincarsoule from "./Logincarsoule";
import Api from "@/resource/MemberApi";
import NewLoginOtp from "./NewLoginOtp.vue";
export default {
  name: "OtpVerify",
  components: {
    // OTPTimer,
    'login-in-carsoule': Logincarsoule,
    'login-otp': NewLoginOtp
    // SubmitIssue
  },
  data() {
    return {
      otp:'',
      errorClass : '',
      otpLoader: false,
      formLoader: false,
      otpErrorFlag: false,
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters({
      verifiedIdentitySelectedInfo: 'verifiedIdentitySelectedInfo'
    }),
  },
  methods: {
    routeToLogin () {
      let app = this
      app.$router.push('/login')
    },
    onChangeOTP(otp) {
      let app = this
      app.otp = otp
      app.verifyToken()
    },
    verifyToken() {
      let app = this
      if ((!this.otp) || (this.otp.trim() === "")) {
        app.otpErrorFlag = true;
        app.errorClass = 'highlight_otp'
        app.errorMsg = "Please enter  OTP sent to your  registered email  to proceed";

      } else if ((app.otp.length < 6)) {
        app.otpErrorFlag = true;
        app.errorClass = 'highlight_otp'
        app.errorMsg = "Please enter  6 digit OTP inorder to proceed";
      } else {
      app.formLoader = true
      app.errorClass = false;
      Api
          .post('v2/auth/reset-verify-otp',
              {
                option: app.verifiedIdentitySelectedInfo.option,
                data: app.verifiedIdentitySelectedInfo.data,
                reset_code: app.otp,
              })
          .then((response) => {
            if (response.data.status == "success") {
              app.$store.commit("setOtpCode", app.otp);
              app.$router.push('/reset-password')
            }
          })
          .catch((error) => {
            app.errorClass = 'highlight_otp'
            if (error.response.data.status == "error") {
              app.otpErrorFlag = true
              app.errorMsg = error.response.data.message
            }
            app.verifyLoader = false;
          }).finally(() => {
        app.formLoader = false;
      } )
    }
    },
    handleOnChange () {
      let app = this
      if (app.otpErrorFlag) {
        app.otpErrorFlag = false
        app.errorClass = ''
        app.errorMsg = ''
      }
    },
    sendOTP () {
      let app = this;
      app.otpLoader = true;
      app.$store.dispatch('verifiedIdentitySelectedInfo',  app.verifiedIdentitySelectedInfo)
      Api
          .post('v2/auth/reset-generate-otp', app.verifiedIdentitySelectedInfo)
          .then(function(response) {
            if (response.data.status == "success") {
              app.otpLoader = false;
              app.$router.push('/verify-otp')
              helper.infoMessage(
                  app,
                  response.data.status,
                  response.data.message
              )
            }
          })
          .catch(function(error) {
            if (error.response.data.status == "error") {
              app.otpLoader = false;
              helper.infoMessage(
                  app,
                  error.response.data.status,
                  error.response.data.message
              );
            }
          });
    }
  }
};
</script>
  <style src="@/assets/css/authen.css"></style>
  <style src="@/assets/css/newLogin.css"></style>
  <style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
.rep-icon-login img {
  width: 100px;
}
</style>

<style scoped>
.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
